import "../../public/assets/scss/app.scss";
import { useRouter } from "next/router";
import Head from "next/head";
import { withoutLayoutThemePath } from "Data/OthersPageData";
import { ToastContainer } from "react-toastify";
import "../../i18n";
import "../../public/assets/scss/app.scss";
import LayoutProvider from "helper/Layout/LayoutProvider";
import Layout from "../layout";
import { CustomizerProvider } from "helper/Customizer/CustomizerProvider";
import { UserDataProvider, useUserData } from "helper/UserData";
import NoSsr from "utils/NoSsr";
import { searchableMenuType } from "helper/Layout";
import { useEffect, useState } from "react";
import { getSidebarMenuFromRedis } from "@/layout/Sidebar/menu";
import { sidebarMenuType } from "Types/LayoutDataType";


const Myapp = ({ Component, pageProps }: any) => {
  const [menuList, setMenuList] = useState<sidebarMenuType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMenu = async () => {
      setLoading(false);
    };
    loadMenu();
  }, []);

  const getLayout = Component.getLayout || ((page: any) => <Layout>{page}</Layout>);
  const router = useRouter();
  const currentUrl = router.asPath;
  const updatedPath = currentUrl.includes("?") ? currentUrl.split("?")[0] : currentUrl;

  if (loading) return null; // or a loading spinner

  return (
    <NoSsr>
      <Head>
        <title>{process.env.NEXT_PUBLIC_APP_TITLE || "IDO - Integrated Digital Office"}</title>
      </Head>
      {withoutLayoutThemePath.includes(updatedPath) ? (
        <Component {...pageProps} />
      ) : (
        <CustomizerProvider>
          <UserDataProvider>
            <LayoutProvider menuList={menuList}>{getLayout(<Component {...pageProps} />)}</LayoutProvider>
          </UserDataProvider>
        </CustomizerProvider>
      )}
      <ToastContainer />
    </NoSsr>
  );
};


export default Myapp;
